import { render, staticRenderFns } from "./ProductsFundEquityList.vue?vue&type=template&id=04502f7f&scoped=true&"
import script from "./ProductsFundEquityList.vue?vue&type=script&lang=js&"
export * from "./ProductsFundEquityList.vue?vue&type=script&lang=js&"
import style0 from "./ProductsFundEquityList.vue?vue&type=style&index=0&id=04502f7f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04502f7f",
  null
  
)

export default component.exports